<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:0;">
      <el-row :gutter="15">
        <el-col :md="5" style="margin-bottom: 15px">
          <!-- 操作按钮 -->
          <div class="ele-table-tool ele-table-tool-default scope-tool">
            <el-button @click="showEdit = true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
            <el-button @click="edit" type="warning" icon="el-icon-edit" class="ele-btn-icon" :disabled="!current" size="small">修改 </el-button>
            <el-button @click="remove" type="danger" icon="el-icon-delete" class="ele-btn-icon" :disabled="!current" size="small">删除 </el-button>
          </div>
          <!-- 数据表格 -->
          <ele-data-table
            ref="table"
            :config="table"
            :data="scopeData"
            :current.sync="current"
            highlight-current-row
            :height="tbHeight"
            class="dict-table"
            @row-click="click"
          >
            <el-table-column type="index" width="45" align="center" />
            <el-table-column prop="info" label="巡查项目" show-overflow-tooltip />
          </ele-data-table>
        </el-col>
        <el-col :md="6" style="margin-bottom: 15px">
          <div class="org-tree-group">
            <div class="ele-table-tool ele-table-tool-default">
              <el-button
                :disabled="currentRange && currentRange.type == 2"
                @click="addRange"
                type="primary"
                icon="el-icon-plus"
                class="ele-btn-icon"
                size="small"
                >添加
              </el-button>
              <el-button @click="editRange" type="warning" icon="el-icon-edit" class="ele-btn-icon" :disabled="!currentRange" size="small"
                >修改
              </el-button>
              <el-button @click="removeRange" type="danger" icon="el-icon-delete" class="ele-btn-icon" :disabled="!currentRange" size="small"
                >删除
              </el-button>
            </div>
            <el-tree
              ref="tree"
              :data="rangeData"
              :props="{ label: 'info' }"
              :expand-on-click-node="false"
              node-key="id"
              :default-expand-all="true"
              @node-click="chooseRange"
              highlight-current
            />
          </div>
        </el-col>
        <el-col :md="13" style="margin-bottom: 15px">
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="addResult" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
            <!--            <el-button @click="removeResult" type="danger" icon="el-icon-delete" class="ele-btn-icon"-->
            <!--                        size="small">删除-->
            <!--            </el-button>-->
          </div>
          <div class="resultGroup">
            <ele-data-table ref="resultTable" :config="resultTable" highlight-current-row class="dict-table" :initLoad="false">
              <el-table-column type="index" width="45" align="center" />
              <el-table-column prop="info" label="描述" show-overflow-tooltip />
              <el-table-column prop="subtractState" label="结果状态" show-overflow-tooltip>
                <template #default="{ row }">
                  {{ row.subtractState == 1 ? '加分' : row.subtractState == 2 ? '减分' : row.subtractState == 0 ? '不加不减' : '' }}
                </template>
              </el-table-column>
              <el-table-column prop="subtractPoints" label="分值" show-overflow-tooltip>
                <template #default="{ row }">
                  {{
                    row.subtractState == 1
                      ? '+' + row.subtractPoints
                      : row.subtractState == 2
                      ? '-' + row.subtractPoints
                      : row.subtractState == 0
                      ? row.subtractPoints
                      : ''
                  }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="230px" align="center" :resizable="false">
                <template #default="{ row }">
                  <el-link @click="editResult(row)" icon="el-icon-edit" type="primary" :underline="false">修改</el-link>
                  <el-popconfirm title="确定要删除此结果设置吗？" @onConfirm="removeResult(row)" class="ele-action">
                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false">删除</el-link>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </ele-data-table>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- 巡查项目弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改巡查项目' : '添加巡查项目'"
      :visible.sync="showEdit"
      width="400px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="巡查项目:" prop="info">
          <el-input v-model="editForm.info" placeholder="请输入巡查项目名称" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
    <!--编辑弹窗-->
    <el-dialog
      :title="rangeForm.id ? '修改巡查范围' : '添加巡查范围'"
      :visible.sync="showRange"
      width="400px"
      @closed="rangeForm = {}"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="rangeForm" ref="rangeForm" :rules="rangeRules" label-width="110px">
        <el-row :gutter="15">
          <el-col>
            <el-form-item v-if="currentRange != null" label="上级组织:" prop="parentId">
              <treeselect
                v-model="rangeForm.parentId"
                :options="rangeList"
                placeholder="请选择所属区域"
                :defaultExpandLevel="4"
                :normalizer="
                  (d) => {
                    return { id: d.id, label: d.info };
                  }
                "
              />
            </el-form-item>
            <el-form-item label="巡查范围名称:" prop="info">
              <el-input v-model="rangeForm.info" placeholder="请输入巡查范围名称" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showRange = false">取消</el-button>
        <el-button type="primary" @click="saveRange(rangeForm.id)">保存</el-button>
      </div>
    </el-dialog>
    <!-- 巡查项目弹窗 -->
    <el-dialog
      :title="resultForm.id ? '修改巡查结果设置' : '添加巡查结果设置'"
      :visible.sync="showResult"
      width="400px"
      @closed="resultForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="resultForm" ref="resultForm" :rules="resultRules" label-width="100px">
        <el-form-item label="描述:" prop="info">
          <el-input v-model="resultForm.info" placeholder="请输入描述" class="ele-block" clearable />
        </el-form-item>
        <el-form-item label="结果状态:" prop="subtractState">
          <el-select v-model="resultForm.subtractState" placeholder="结果状态" class="ele-block" clearable>
            <el-option label="加分" :value="'1'" />
            <el-option label="减分" :value="'2'" />
            <el-option label="不加不减" :value="'0'" />
          </el-select>
        </el-form-item>
        <el-form-item label="分值:" prop="subtractPoints">
          <el-input v-model="resultForm.subtractPoints" placeholder="请输入分值" class="ele-block" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showResult = false">取消</el-button>
        <el-button type="primary" @click="saveResult(resultForm.id)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import {
    addScope,
    updateScope,
    delScope,
    getRangeList,
    getAllScope,
    getInfoAllRange,
    addRange,
    updateRange,
    delRange,
    addSearchResult,
    updateSearchResult,
    delSearchResult,
  } from '@/config/api';

  export default {
    name: 'Index',
    components: { Treeselect },
    data() {
      return {
        scopeData: [], //巡查项目数据
        table: {
          // 表格配置
          page: false,
        },
        current: null, // 表格选中数据
        showEdit: false, // 是否显示表单弹窗
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          info: [{ required: true, message: '请输入巡查项目名称', trigger: 'blur' }],
        },
        choose: [], //巡查范围树选择
        rangeData: [], //巡查范围数据
        showRange: false, //巡查范围弹窗
        currentRange: null,
        rangeForm: {},
        rangeRules: {
          // 表单验证规则
          info: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        },
        rangeList: [],
        scopeId: null,
        rangeId: null,
        resultTable: {
          url: '/school/schoolSearch/getSearchResultList',
          method: 'GET',
          where: {
            scopeId: '',
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        resultForm: {},
        resultRules: {
          info: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          subtractState: [{ required: true, message: '请选择结果状态', trigger: 'change' }],
          subtractPoints: [{ required: true, message: '请输入分值', trigger: 'blur' }],
        },
        showResult: false,
      };
    },
    computed: {
      /* 表格固定高度 */
      tbHeight() {
        return this.$store.state.theme.screenWidth < 992 ? undefined : 'calc(100vh - 214px)';
      },
    },
    mounted() {
      this.queryScopedata();
    },
    methods: {
      // 查询巡查项目列表
      queryScopedata() {
        getAllScope().then((res) => {
          if (res.data.resCode == 200) {
            this.scopeData = res.data.data;
            this.$refs.table.setCurrentRow(res.data.data[0]);
            this.scopeId = res.data.data[0].id;
            this.rangeForm.scopeId = res.data.data[0].id;
            this.queryRangetree(res.data.data[0].id);
            this.queryRangeList(res.data.data[0].id);
            this.resultTable.where.scopeId = res.data.data[0].id;
            this.$refs.resultTable.reload();
          }
        });
      },
      // 查询巡查范围数据
      queryRangeList(scopeId) {
        let data = { scopeId: scopeId };
        getInfoAllRange(data).then((res) => {
          if (res.data.resCode == 200) {
            this.rangeList = res.data.data;
          }
        });
      },
      // 编辑巡查项目
      edit() {
        this.editForm = Object.assign({}, this.current);
        this.showEdit = true;
      },
      // 添加与修改巡查项目
      save(id) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (id == undefined) {
              //添加巡查项目
              addScope(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.queryScopedata();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              //修改巡查项目
              updateScope(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.queryScopedata();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      // 删除巡查项目
      remove() {
        this.$confirm('确定要删除选中的巡查项目吗?', '提示', {
          type: 'warning',
        }).then(() => {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('id', this.current.id);
          delScope(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.showEdit = false;
              this.$message({ type: 'success', message: res.data.resMsg });
              this.queryScopedata();
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      // 选择巡查项目获取id
      click(row) {
        this.scopeId = row.id;
        this.rangeForm.scopeId = row.id;
        this.resultTable.where.scopeId = row.id;
        this.$refs.resultTable.reload();
        this.queryRangetree(row.id);
      },
      //获取巡查范围树
      queryRangetree(scopeId) {
        let data = { scopeId: scopeId };
        getRangeList(data).then((res) => {
          if (res.data.resCode == 200) {
            this.rangeData = this.$util.toTreeData(res.data.data, 'id', 'parentId');
            this.currentRange = null;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 点击巡查范围
      chooseRange(row) {
        if (row != null) {
          this.$refs.tree.setCurrentKey(row.id);
          this.rangeId = row.id;
          this.scopeId = row.scopeId;
          this.currentRange = row;
        } else {
          this.currentRange = null;
        }
      },
      // 添加巡查范围弹窗
      addRange() {
        if (this.currentRange == null) {
          this.rangeForm.parentId = 0;
        } else {
          this.queryRangeList(this.currentRange.scopeId);
          this.rangeForm.parentId = this.currentRange.id;
          this.rangeForm.scopeId = this.currentRange.scopeId;
        }
        this.showRange = true;
      },
      // 编辑巡查范围弹窗
      editRange() {
        this.rangeForm = Object.assign({}, this.currentRange);
        this.showRange = true;
      },
      //保存和修改巡查范围
      saveRange(id) {
        this.$refs['rangeForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.rangeForm) {
              if (this.rangeForm[key] !== null && this.rangeForm[key] !== undefined) {
                formData.append(key, this.rangeForm[key]);
              }
            }
            if (id == undefined) {
              //添加巡查项目
              formData.append('scopeId', this.scopeId);
              addRange(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showRange = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.queryRangetree(this.scopeId);
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              //修改巡查项目
              updateRange(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showRange = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.queryRangetree(this.scopeId);
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      // 删除巡查范围
      removeRange() {
        this.$confirm('确定要删除选中的机构吗?', '提示', {
          type: 'warning',
        }).then(() => {
          let formData = new FormData();
          formData.append('id', this.currentRange.id);
          delRange(formData).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: '已删除' });
              this.queryRangetree(this.scopeId);
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      // 添加结果设置弹窗
      addResult() {
        // if(this.currentRange){
        this.showResult = true;
        // this.rangeId = this.currentRange.id;
        this.scopeId = this.currentRange.scopeId;
        // }else {
        //   this.$message.error('请选择巡查范围');
        // }
      },
      // 编辑结果设置弹窗
      editResult(row) {
        this.resultForm = Object.assign({}, row);
        this.showResult = true;
      },
      // 保存和修改巡查结果设置
      saveResult(id) {
        this.$refs['resultForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.resultForm) {
              if (this.resultForm[key] !== null && this.resultForm[key] !== undefined) {
                formData.append(key, this.resultForm[key]);
              }
            }
            if (id == undefined) {
              //添加巡查结果设置
              formData.append('scopeId', this.scopeId);
              // formData.append('rangeId',this.rangeId);
              addSearchResult(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showResult = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.resultTable.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              //修改巡查结果设置
              updateSearchResult(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showResult = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.resultTable.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      // 删除巡查结果设置
      removeResult(row) {
        const loading = this.$loading({ lock: true });
        let formData = new FormData();
        formData.append('id', row.id);
        delSearchResult(formData).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.showEdit = false;
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.resultTable.reload();
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
    },
  };
</script>

<style scoped>
  .scope-tool {
    justify-content: space-around;
  }
  .org-tree-group {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(115vh - 275px);
    box-sizing: border-box;
    overflow-x: auto;
  }

  .org-tree-group >>> .el-tree-node__content {
    height: 40px;
  }

  .org-tree-group >>> .el-tree-node__content > .el-tree-node__expand-icon {
    margin-left: 10px;
  }
  .resultGroup {
    border: 1px solid hsla(0, 0%, 60%, 0.15);
    height: calc(100vh - 215px);
    box-sizing: border-box;
    overflow-x: auto;
  }
</style>
